<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="true">
    <p style="color: white"> Please Wait Loading... </p>
</ngx-spinner>
<div class="app-body">
    <main class="main d-flex p-2">
        <div class="col-md-4 col-md-offset-4">
            <form [formGroup]="loginFormGroup">
                <div class=" panel panel-default ">
                    <div class="panel-body ">
                        <div class="text-center ">
                            <h3><i class="fa fa-lock fa-4x "></i></h3>
                            <h2 class="text-center ">Forgot Password?</h2>
                            <p>Enter Your E-mail to Get Resetlink</p>
                            <div class="panel-body ">
                                <div class="form-group ">

                                        <input placeholder="Email address " class="form-control " type="email"
                                        formControlName="emailId" [ngClass]="{ 'is-invalid': submitted && emailId.errors }">

                                </div>
                                <div *ngIf="submitted && emailId.errors" class="invalid-feedback">
                                    <div *ngIf="emailId.errors.required">Email Id Is
                                        Required</div>
                                    <div *ngIf="emailId.errors.email"> In-Valid
                                        E-Mail
                                        Address</div>
                                </div>
                                <div class="form-group">

                                    <button class="btn btn-lg btn-primary " type="submit" (click)="getLink()"
                                    [disabled]="loginFormGroup.invalid" >Get Link</button><br>
                                    <br><a href="#login" class="text-body"> <i class="fa fa-arrow-left"> &nbsp;</i>Back To Login page !</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </main>
</div>
